/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 */
export function randomInteger(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns a random element from the given array
 */
export function randomChoice<T>(...choices: T[]): T {
  return choices[randomInteger(0, choices.length - 1)];
}
